import React from 'react';
import {Col, Row} from "reactstrap";
import SwiperCourse from "./SwiperCourse";
import iconHome from "../../../assets/img/icons/Title-png.png";
import {history} from "../../../history";

const CoursesHome = ({course}) => {
    return (
        <>

            <div className="d-flex align-items-center px-md-3">
                <h2 className="my-auto home-label">
                    {course?.title}
                </h2>
                <img className="my-auto ml-1" src={iconHome} alt="icon-home" width={100} />
                <div className="home-line"></div>
            </div>

            <div className="courses-home-page">
                {/*<Row>*/}
                {/*    <Col sm={12} md={8}>*/}
                {/*        <div className="mt-2">*/}
                {/*            <p className="text-justify" dangerouslySetInnerHTML={{*/}
                {/*                __html: course?.content*/}
                {/*            }}>*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*    <Col sm={12} md={4}>*/}
                {/*        <div className="img-home-course">*/}
                {/*            <img src={course?.image} alt={course?.image}/>*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*</Row>*/}


                {(course?.courses && course?.courses.length > 0)?
                <SwiperCourse data={course?.courses}/>

                : <p className="w-100 mt-4 mb-5 text-center">دوره ای موجود نیست.</p>
                }


                <div className="text-center btn-all-course">
                    <button className="learn-more" onClick={() => history.push(`/courses/${course.slug}`)}>
                    <span className="circle" aria-hidden="true">
                      <span className="icon arrow"></span>
                    </span>
                        <span className="button-text">مشاهده بیشتر</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default CoursesHome;
